/**
 * Downscale + recompress an image File to a JPEG. Used for survey evidence
 * uploads and property facility photos. Defaults match historical caller
 * defaults (1200×800, q=0.8).
 */
export function resizeImage(
  file: File,
  maxWidth = 1200,
  maxHeight = 800,
  quality = 0.8
): Promise<File> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      reject(new Error("Canvas 2D context unavailable"));
      return;
    }
    const img = new Image();

    img.onload = () => {
      const ratio = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
      const newWidth = img.width * ratio;
      const newHeight = img.height * ratio;
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas toBlob returned null"));
            return;
          }
          resolve(
            new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
              type: "image/jpeg",
              lastModified: Date.now(),
            })
          );
        },
        "image/jpeg",
        quality
      );
    };
    img.onerror = () => reject(new Error("Image failed to load"));
    img.src = URL.createObjectURL(file);
  });
}
